import React from 'react';
import { useTranslation } from 'react-i18next';

// Custom Components
import ModelTable from '@/ui/Table/ModelTable';

// Types
import { DCRecord } from '@/@types/lib/dataController';
import { RowActionFn, AllowRowActionFn } from '@/@types/ui/Table';
import { IDataController } from '@/lib/DataController';
import TableButtonShow3D from '../Table/ActionButtons/TableButtonShow3D';

type PhotoCentricTableProps = {
  records: Array<DCRecord>;
  onRowSelect: (id: number) => void;
  onRowAction?: RowActionFn;
  allowRowAction?: AllowRowActionFn;
  rowSelectedCustom?: number;

  titleToken: string;
  dc: IDataController;
  viewName?: string;

  allowShow3D?: boolean;
};

const PhotoCentricTable = (props: PhotoCentricTableProps) => {
  const { t } = useTranslation();
  const { records, onRowSelect, onRowAction, allowRowAction,rowSelectedCustom } = props;
  const { titleToken, dc, viewName, allowShow3D = false, } = props;

  const handleRowSelect = (
    evt: React.SyntheticEvent,
    sel: { [key: string]: DCRecord }
  ) => {
    const record = sel[Object.keys(sel)[0]];
    const id = Number(record.id);

    onRowSelect(id);
  };

  return (
    <ModelTable
      title={t(titleToken)}
      viewName={viewName || 'processing'}
      records={records}
      dc={dc}
      allowSelection="one"
      allowFilter
      allowExport={false}
      allowAdd={false}
      allowColumnPicker
      // allowEdit={false}
      // disableControls
      onRowAction={onRowAction !== undefined ? onRowAction : () => {}}
      onRowClick={handleRowSelect}
      // initialPageSize={25}
      allowRowAction={allowRowAction || (() => true)}
      // trackTableState={false}
      // unselectRow
      rowSelectedCustom={rowSelectedCustom}
  >
    {allowShow3D ? <TableButtonShow3D /> : null}
  </ModelTable>
  );
};

export default PhotoCentricTable;
